import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { buildPaletteFromMetadata, PaletteTokenMetadata, type Token } from './panw-palette/token-metadata';

const interactiveTokens = [
  { propertyPath: 'control.default', tokenName: '--bg-interactive-control-default' },
  { propertyPath: 'control.hover', tokenName: '--bg-interactive-control-default-hover' },
  { propertyPath: 'control.disabled', tokenName: '--bg-interactive-control-disabled' },
  { propertyPath: 'control.selected', tokenName: '--bg-interactive-control-selected' },
  { propertyPath: 'control.selected-hover', tokenName: '--bg-interactive-control-selected-hover' },
  { propertyPath: 'control.handle', tokenName: '--bg-interactive-control-handle' },
  { propertyPath: 'control.handle-disabled', tokenName: '--bg-interactive-control-handle-disabled' },
  { propertyPath: 'destructive.default', tokenName: '--semantic-bg-interactive-destructive-default' },
  { propertyPath: 'destructive.hover', tokenName: '--semantic-bg-interactive-destructive-hover' },
  { propertyPath: 'destructive.disabled', tokenName: '--semantic-bg-interactive-destructive-disabled' },
  { propertyPath: 'destructive.subtle.default', tokenName: '--semantic-bg-interactive-destructive-subtle-default' },
  { propertyPath: 'highlight.default', tokenName: '--semantic-bg-interactive-highlight-default' },
  { propertyPath: 'highlight.hover', tokenName: '--semantic-bg-interactive-highlight-hover' },
  { propertyPath: 'neutral.default', tokenName: '--semantic-bg-interactive-neutral-default' },
  { propertyPath: 'neutral.hover', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'neutral.active', tokenName: '--semantic-bg-interactive-neutral-active' },
  { propertyPath: 'neutral.disabled', tokenName: '--semantic-bg-interactive-neutral-disabled' },
  { propertyPath: 'neutral.focus', tokenName: '--semantic-bg-interactive-neutral-focus' },
] satisfies Token[];

export const interactiveTokenMetadata: PaletteTokenMetadata = {
  componentName: 'interactive',
  tokens: interactiveTokens,
};

export const interactive = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['interactive'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(interactiveTokenMetadata.tokens, tokens, xcorTokens);
  }

  // we shouldn't hit this as the code path is gated, setting everything to red
  // so that we can see if something is wrong
  return {
    neutral: {
      default: '#FF0000',
      hover: '#FF0000',
      active: '#FF0000',
      disabled: '#FF0000',
      focus: '#FF0000',
      handle: '#FF0000',
      handleDisabled: '#FF0000',
    },
    highlight: {
      default: '#FF0000',
      hover: '#FF0000',
    },
  };
};
